import * as React from "react";
import {
  JoinDrawerFragment,
  JoinDrawerFragmentProps,
} from "../join-drawer-fragment";

import {
  RightDrawer,
  RightDrawerProps,
  useRightDrawerLocalUiContext,
} from "./right-drawer";

interface JoinDrawerProps {
  present?: RightDrawerProps["present"];
  drawerClassName?: RightDrawerProps["drawerClassName"];
  handleBack?: RightDrawerProps["handleBack"];
  handleClose?: RightDrawerProps["handleClose"];

  useInitialState: DrawerCompositionProps["useInitialState"];
  allowJoining?: DrawerCompositionProps["allowJoining"];
}
export const JoinDrawer: React.FunctionComponent<JoinDrawerProps> = (props) => {
  return (
    <RightDrawer
      present={props.present}
      drawerClassName={props.drawerClassName}
      handleBack={props.handleBack}
      handleClose={props.handleClose}
    >
      <DrawerComposition
        useInitialState={props.useInitialState}
        allowJoining={props.allowJoining}
      />

      {props.children || []}
    </RightDrawer>
  );
};

interface DrawerCompositionProps {
  useInitialState: JoinDrawerFragmentProps["useInitialState"];
  allowJoining: JoinDrawerFragmentProps["allowJoining"];
}
const DrawerComposition: React.FunctionComponent<DrawerCompositionProps> = (
  props
) => {
  const { handleBack, handleClose } = useRightDrawerLocalUiContext();
  return (
    <React.Fragment>
      <JoinDrawerFragment
        useInitialState={props.useInitialState}
        handleBack={handleBack}
        handleClose={handleClose}
        allowJoining={props.allowJoining}
      />
    </React.Fragment>
  );
};
